import React from 'react';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { put, all } from 'redux-saga/effects';
import { logout } from './loginSystem/actions';
import { notify } from './notificationSystem/actions';

function translateErrorMessage(message) {
  return <FormattedMessage id={message} key="error-msg" />;
}

function getErrorReason(error = {}) {
  const message = _.get(error, 'response.data.message');
  // return message;
  // return message ? ` Reason: ${message}` : null;
  return message ? `${message.includes('filtering') || message.includes('Sales point translated') ? "" : 'Reason:'}  ${message}` : null;
}

export default function* handleError(error, msg, ...effects) {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    if (error.response.status === 401) {
      // If the error happened because the user tried to make a request, but was
      // unauthorized, for instance if the user's token has expired, the user
      // should be logged out
      yield put(logout());
    } else {
      yield all(effects);
      const translatedError = translateErrorMessage(msg);
      const reason = getErrorReason(error);
      yield put(
        notify({
          message: [translatedError, reason],
          variant: 'error',
          duration: reason.length > 300 ? 10000 :8000,
          reason: reason.trim().includes("Failed to de-activate filtering button")
        })
      );
    }
  } else {
    console.error(error);
    yield all(effects);
    yield put(
      notify({
        message: <FormattedMessage id="notify.requestError" />,
        variant: 'error'
      })
    );
  }
}
